import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public constructor(private readonly msalService: MsalService) { }

  public get LoggedIn(): boolean {
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length === 0) {
      // No user signed in
      this.msalService.instance.loginRedirect();
    }
    return !!accounts[0];
  }

  public get UserName(): string {

    const accounts = this.msalService.instance.getAllAccounts();
    let user;
    if (accounts.length === 0) {
      // No user signed in
      // this.msalService.instance.loginRedirect();
    } else {
      user = accounts[0];
    }
    return user && user.name ? user.name : '';
  }
}
